module.exports = __webpack_public_path__ + "static/img/101020.a2949f7c.png";